import IsValidDate from "./IsValidDate";

export class Serializer {
    public static fromQueryParams(query: string): unknown {
        query = query.substring(query.indexOf("?") + 1);
        const re = /([^&=]+)=?([^&]*)/g;
        const decodeRE = /\+/g;
        const decode = (str: string) => {
            return decodeURIComponent(str.replace(decodeRE, " "));
        };
        const params: any = {};
        let e;
        while ((e = re.exec(query))) {
            let k = decode(e[1]);
            const v = decode(e[2]);
            if (k.substring(k.length - 2) === "[]") {
                k = k.substring(0, k.length - 2);
                (params[k] || (params[k] = [])).push(v);
            } else {
                params[k] = v;
            }
        }

        const assign = (obj: any, keyPath: string[], value: string) => {
            const lastKeyIndex = keyPath.length - 1;
            for (let i = 0; i < lastKeyIndex; ++i) {
                const key = keyPath[i];
                const keyIndex = parseInt(key);
                const isNextKeyIndex = i + 1 < lastKeyIndex && !isNaN(parseInt(keyPath[i + 1]));
                if (isNextKeyIndex) {
                    if (!Array.isArray(obj[key])) {
                        obj[key] = [];
                    }
                    obj = obj[key];
                } else if (!isNaN(keyIndex)) {
                    if (!obj[keyIndex]) {
                        obj.splice(keyIndex, 0, {});
                    }
                    obj = obj[keyIndex];
                } else {
                    if (!(key in obj)) {
                        obj[key] = {};
                    }
                    obj = obj[key];
                }
            }
            obj[keyPath[lastKeyIndex]] = value;
        };

        for (const prop in params) {
            const structure = prop.split("[");
            if (structure.length > 1) {
                const path: string[] = [];
                structure.forEach(function (item) {
                    const key = item.replace(/[?[\]\\ ]/g, "");
                    path.push(key);
                });
                assign(params, path, params[prop]);
                delete params[prop];
            }
        }
        return params;
    }
    public static toQueryParamsNotEmptyOnly(obj: unknown, prefix = "") {
        return Serializer.toQueryParams(obj, prefix, false);
    }
    public static toQueryParams(obj: unknown, prefix = "", includeEmptyValues = true): string {
        const str: string[] = [];
        let key: string;
        if (typeof obj === "object" && obj) {
            for (key in obj) {
                if (obj.hasOwnProperty.call(obj, key)) {
                    const k = prefix ? prefix + "[" + key + "]" : key,
                        v = obj[key as keyof typeof obj];
                    if (typeof v !== "boolean" && !v && !includeEmptyValues) {
                        continue;
                    } else {
                        if (v !== null && typeof v === "object") {
                            if (IsValidDate(v)) {
                                let stringValue = (v as Date).toISOString();
                                if (k.toLowerCase().indexOf("date") >= 0) {
                                    stringValue = this.formatDate(v as Date);
                                }
                                str.push(encodeURIComponent(k) + "=" + encodeURIComponent(stringValue));
                            } else {
                                str.push(Serializer.toQueryParams(v, k, includeEmptyValues));
                            }
                        } else if (k.toLowerCase().indexOf("geometry") === 0) {
                            const value = JSON.parse(v) as GeoJSON.FeatureCollection;
                            if (!value["features"].length) {
                                continue;
                            } else {
                                str.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
                            }
                        } else {
                            str.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
                        }
                    }
                }
            }
            return str.join("&");
        }
        return "";
    }
    public static formatDate(d: Date) {
        let month = "" + (d.getMonth() + 1),
            day = "" + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) {
            month = "0" + month;
        }
        if (day.length < 2) {
            day = "0" + day;
        }

        return [year, month, day].join("-");
    }
}
